import { Blockquote, Amazon, Vocabulary, SoThisIsChristmasIndex, Instagram, AffiliateBanner } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Blockquote,
  Amazon,
  Vocabulary,
  SoThisIsChristmasIndex,
  Instagram,
  AffiliateBanner,
  React
};